import "normalize.css/normalize.css";
import getOr from 'lodash/fp/getOr';

import { ROOT_GLOBAL } from "../../../global/root";

import { embedAllTrack } from "../../../utils/script";
import { isMobileByWidth } from "../../../utils/utils";
import { setUpSliderLP } from "../components/SliderBase";

import "./style.scss";
import { apiCreateTicket } from "../../../utils/api";
import { setUpFormLP } from "../components/FormBase";
import { getExtensionLink, isNormalAndroid } from "../../../utils/browser";
import { LIST_FIELDS } from "../components/FormBase/constant";
import { LocalStorage } from "../../../models/LocalStorage";
import { changeQueryString, changeUtmParams, historyPushState } from "../../../utils/url";
import { setUpFAQLP } from "../components/FAQBase";
import AvailableStore from "../../../components/AvailableStore";
import Header from "../../../components/Header";
import { DCStatic } from "../../../models/DCStatic";

const sliderOptions = {
  autoplaySpeed: 10000
}

const isMobile = isMobileByWidth();

const fieldsVoucherForm = [
  { name: LIST_FIELDS.NAME },
  { name: LIST_FIELDS.PHONE },
  { name: LIST_FIELDS.EMAIL },
  { name: LIST_FIELDS.ADDRESS },
]

embedAllTrack();

initEvent();
initData();

function initEvent() {
  new Header({ parent: ".section.section-header" });
  setUpEventCTV();
  setUpFormLP({
    selector: ".section-receive-voucher #voucher_form",
    type: "voucher_register",
    fields: fieldsVoucherForm,
    button: "landingpageCTV_receivedNow",
    title: "landingpageCTV_shoppingExperience",
    subTitle: "landingpageCTV_shoppingExperienceDes",
    icon: require("../../../assets/images/icons/loveMessage.svg")
  }, onSubmitForm);
}

function initData() {
  $(".section-become-ctv .btn-register .btn").on("click", function () {
    redirectRegisterCTV("partner-register");
  });

  $(".section-bottom-banner .btn-register .btn").on("click", function () {
    redirectRegisterCTV("partner-register");
  });

  if (isMobile) {
    $(".section-with-us .apps").removeClass("hide");
    $(".section-with-us .btn-install").addClass("hide");
    if (isNormalAndroid()) {
      $(".section-with-us .apps .chplay").removeClass("hide");
      $(".section-with-us .apps .appstore").addClass("hide");
    } else {
      $(".section-with-us .apps .chplay").addClass("hide");
      $(".section-with-us .apps .appstore").removeClass("hide");
    }
  } else {
    $(".section-with-us .apps").addClass("hide");
    $(".section-with-us .btn-install").removeClass("hide");
  }

  let bannerData = {
    desktop: [{
      image: "https://cdn.dutycast.com/dutycast/static/media/banner/Banner_Slider_CTV_d_2_no_btn.jpg?min-w=1440",
      url: ROOT_GLOBAL.CTV_REGISTER,
      button: require("../../../assets/images/lpCTV/button_join_CTV_2.png")
    }],
    mobile: [{
      image: "https://cdn.dutycast.com/dutycast/static/media/banner/Banner_Slider_CTV_m_2.jpg?min-w=1440",
      url: ROOT_GLOBAL.CTV_REGISTER
    }],
    thumbnail: "https://cdn.dutycast.com/dutycast/static/media/banner/Banner_Slider_CTV_d_2.jpg?min-w=1440"
  }
  $("meta[property='og:image']").attr("content", bannerData.thumbnail);
  $("meta[property='twitter:image']").attr("content", bannerData.thumbnail);
  setUpBannerLP(bannerData);
  window.bannerData = bannerData;
  window.isMobile = isMobile;
  $(window).on('resize', function () {
    if (isMobileByWidth()) {
      if (!window.isMobile) {
        setUpBannerLP(window.bannerData);
        window.isMobile = true;
      }
    } else {
      if (window.isMobile) {
        setUpBannerLP(window.bannerData);
        window.isMobile = false;
      }
    }
  });

  new AvailableStore({
    section: ".section.section-branch",
    parent: ".section.section-branch .container .border-box",
    title: "landingpageCTV_helpsYourOrderDirectly",
    // description: "landingpageCTV_websiteBeingUpdated",
    seeAll: "landingpageCTV_viewAll",
    isCallApi: true,
  });

  let answersData = require("./answerQuestion.json").data;
  setUpFAQLP(answersData);
}

function setUpBannerLP(data) {
  let sliderDesktop = getOr([], "desktop")(data), sliderMobile = getOr([], "mobile")(data);
  addSliderBanner(isMobile ? sliderMobile : sliderDesktop)
}

function addSliderBanner(listBanner) {
  let htmlBanner = "";
  listBanner.forEach(element => {
    if (element.image) {
      htmlBanner += `
        ${element.url ? `<div class="banner-redirect" data-href="${element.url}">` : ""}
      <div class="banner-item">
        <img src="${element.image}" alt="" />
        ${element.url && element.url === "/dang-ky-tro-thanh-doi-tac" && element.button ? `
        <div class="position">
          <img alt="button" src="${element.button}">
        </div>
        ` : ""}
      </div>
        ${element.url ? "</div>" : ""}
      `
    }
  });
  if (htmlBanner) {
    setUpSliderLP(".section-banner", htmlBanner, sliderOptions);
    $(" .section-banner .banner-redirect").off("click");
    $(" .section-banner .banner-redirect").on("click", function () {
      let href = $(this).data("href");
      if (href) {
        if (href.includes(ROOT_GLOBAL.CTV_REGISTER)) {
          redirectRegisterCTV("banner");
        } else {
          window.open(href, "_blank");
        }
      }
    });
    $(".section-banner").removeClass("hide");
  } else {
    $(".section-banner").addClass("hide")
  }
}

function setUpEventCTV() {
  $(window).scroll(function () {
    const top = $(this).scrollTop() + $(this).height() - ($(this).width() > 768 ? 200 : 0);
    $('.section-about-us').each(function (i, obj) {
      if (top >= obj.offsetTop) {
        $(obj).find("img").addClass("active");
      }
    });
    $('.section-special').each(function (i, obj) {
      if (top >= obj.offsetTop) {
        $(obj).find(".box").addClass("active");
      }
    });
  });

  $(".section-with-us .btn-install").on("click", function (e) {
    let shopping = $("body").attr("dce_cart");
    if (LocalStorage.hasExtension()) {
      if (shopping) {
        window.open(ROOT_GLOBAL.CHECKOUT + "/" + shopping, "_blank");
      } else {
        window.open(ROOT_GLOBAL.AVAILABLE_STORES, "_blank");
      }
    } else {
      window.open(changeUtmParams(getExtensionLink(), `utm_source=partner-page&utm_campaign=partner-register`), "_blank");
    }
  });
}

function redirectRegisterCTV(utmSource = "") {
  let href = changeUtmParams(window.location.origin + ROOT_GLOBAL.CTV_REGISTER, `utm_source=${utmSource}`)
  if (LocalStorage.isLoggedIn()) {
    window.open(href, "_blank");
  } else {
    let url = changeQueryString("cb", encodeURIComponent(href));
    historyPushState(url);
    DCStatic.authSocial.showAuth();
  }
}

function onSubmitForm(params, callbacks = {}, apiTime) {
  apiCreateTicket(
    params,
    function (data) {
      callbacks.onSuccess(data);
    }, function (error) {
      callbacks.onError(error);
    }, apiTime);
}